module.exports = __webpack_public_path__ + "img/mx.e3f1e4dc.svg";